import { render, staticRenderFns } from "./YearPrice.vue?vue&type=template&id=8e4a61ac&scoped=true&"
var script = {}
import style0 from "./YearPrice.vue?vue&type=style&index=0&id=8e4a61ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4a61ac",
  null
  
)

export default component.exports